import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

interface HelpDropdownProps {
	helpOpen?: boolean;
	setHelpOpen?: React.Dispatch<React.SetStateAction<boolean>>;
	menuOpen?: boolean;
	setMenuOpen?: React.Dispatch<React.SetStateAction<boolean>>;
}

const HELP_ITEMS = [{ label: "FAQs", to: "/faq" }];

export const HelpDropdown: React.FC<HelpDropdownProps> = ({
	helpOpen,
	setHelpOpen,
	menuOpen,
	setMenuOpen,
}) => {
	const [internalOpen, setInternalOpen] = useState(false);
	const wrapperRef = useRef<HTMLDivElement>(null);

	const isOpen = helpOpen !== undefined ? helpOpen : internalOpen;
	const setIsOpen = (val: boolean) => {
		if (setHelpOpen) {
			setHelpOpen(val);
			if (val && setMenuOpen) setMenuOpen(false);
		} else {
			setInternalOpen(val);
		}
	};

	const handleHelpClick = () => {
		const next = !isOpen;
		if (next && menuOpen && setMenuOpen) setMenuOpen(false);
		setIsOpen(next);
	};

	const handleHelpKeyDown = (event: React.KeyboardEvent) => {
		if (event.key === "Enter" || event.key === " ") {
			event.preventDefault();
			handleHelpClick();
		}
	};

	useEffect(() => {
		const handleClickOutside = (event: MouseEvent | TouchEvent) => {
			if (
				wrapperRef.current &&
				!wrapperRef.current.contains(event.target as Node)
			) {
				if (isOpen) setIsOpen(false);
			}
		};

		document.addEventListener("mousedown", handleClickOutside);
		document.addEventListener("touchstart", handleClickOutside);

		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
			document.removeEventListener("touchstart", handleClickOutside);
		};
	}, [isOpen]);

	return (
		<div
			className="vt-pub-help-wrapper"
			ref={wrapperRef}
			data-testid="HelpDropdown-Outer-Div"
		>
			<div
				className="vt-pub-help"
				role="button"
				tabIndex={0}
				onClick={handleHelpClick}
				onKeyDown={handleHelpKeyDown}
				aria-expanded={isOpen}
				aria-haspopup="true"
				aria-controls="vtPubHelpDropdown"
				aria-label="Help menu"
				data-testid="HelpDropdown-Button"
			>
				<div className="vt-pub-flex-overflow-hidden">
					<div className="vt-pub-help-text">Help</div>
				</div>
				<div className="vt-pub-help-icon">
					<img
						src="https://t-t-prod-c3atgyatcbgvfdhc.a02.azurefd.net/images/down_arrow.svg"
						alt="Help dropdown"
					/>
				</div>
			</div>

			<div
				id="vtPubHelpDropdown"
				className={`vt-pub-help-dropdown ${isOpen ? "open" : ""}`}
				aria-label="Help dropdown"
			>
				<div className="vt-pub-help-dropdown-inner">
					{HELP_ITEMS.map(({ label, to }) => (
						<Link
							to={to}
							onClick={() => setIsOpen(false)}
							className="vt-pub-help-dropdown-item"
							key={to}
						>
							<div className="vt-pub-help-dropdown-text">
								{label}
							</div>
						</Link>
					))}
				</div>
			</div>
		</div>
	);
};
